import { cn } from "@/lib/utils.ts";
import { GICS_LEVEL_CONFIG } from "../config.ts";
import type { GicsLevel } from "../types.ts";

interface GicsLevelBadgeProps {
  level: GicsLevel;
  className?: string;
}

export function GicsLevelBadge({ level, className }: GicsLevelBadgeProps) {
  const config = GICS_LEVEL_CONFIG[level];
  return (
    <span
      className={cn(
        "px-2 py-0.5 rounded text-xs font-medium",
        config.bgClass,
        config.textClass,
        className,
      )}
    >
      {config.badge}
    </span>
  );
}
